import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

//CSS
import "./Snackbar.css";

export default function Snackbar({ show, setShow, message }) {
  const [showSnackbar, setShowSnackbar] = useState("");

  useEffect(() => {
    if (show) {
      setShowSnackbar("show");
      setTimeout(() => {
        setShowSnackbar("");
        setShow(false);
      }, 3000); 
    }
  }, [show, setShow]);

  return (
    <div id="snackbar" className={showSnackbar}>
      {message}
    </div>
  );
}

Snackbar.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired
};
